import type { ElementNode } from '../store/editor.store'

/**
 * Bloques que dibujan TODO su interior desde sus ajustes —galería, preguntas,
 * reseñas, antes/después, logos, progreso— y no sus hijos: lo que se metiera
 * dentro no saldría en ningún sitio. Son `div`, así que sin esto el lienzo
 * los trataba como cajas y dejaba soltar o añadir piezas dentro.
 */
export const SEALED_BEHAVIORS = ['gallery', 'faq', 'reviews', 'beforeAfter', 'logos', 'progress'] as const

export function holdsNoChildren(node: Pick<ElementNode, 'behavior'> | null | undefined): boolean {
  const type = node?.behavior?.type
  return Boolean(type && (SEALED_BEHAVIORS as readonly string[]).includes(type))
}
